import { connect } from "react-redux";
import DealInsightsView from "./view";

import { fetchActiveDeals, fetchDealsMetrics } from "src/legacy/redux/actions/dealInsights";
import { fetchIntegrations } from 'src/legacy/redux/actions/integrations';
import { invalidateDealInsights } from "src/legacy/redux/actions/dealInsights";
import { current } from "@reduxjs/toolkit";


import _ from "lodash";
import withUseHooks from "src/legacy/components/withUseHooks";

const mapStateToProps = (state, ownProps) => {

  const isIntegrationsFetching = _.get(state, "legacyRootReducer.settings.integrations.activated.loading", false)
 
  return {
    isIntegrationsFetching,
    allDeals: _.get(state, "legacyRootReducer.dealInsights.allDeals", []),
    isIntegrated: true,
    primaryColor: _.get(state.account, 'theme.primaryColor', '#E50C58'),
    fetching: _.get(state, "legacyRootReducer.dealInsights.fetching", false),
    currentPage: _.get(state, "legacyRootReducer.dealInsights.currentPage", 0),
    totalPages: _.get(state, "legacyRootReducer.dealInsights.totalPages", 1),
    totalRecordsCount: _.get(state, "legacyRootReducer.dealInsights.totalRecordsCount", 0),
    metrics: _.get(state, "legacyRootReducer.dealInsights.metrics.data", {}),
    currency: _.get(state, "accounts.item.currency", "")



  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActiveDeals: (request, params) => {
      return dispatch(fetchActiveDeals(request, params));
    },
    fetchDealsMetrics: () => {
      return dispatch(fetchDealsMetrics());
    },
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    invalidateDealInsights: () => {
      return dispatch(invalidateDealInsights())
    }
  };
};

const DealInsightsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(DealInsightsView);

export default withUseHooks(DealInsightsPage);
